import { AlertProps } from '@mui/material';
import { atom } from 'jotai';

type SimpleAlert = {
    show: boolean;
    title: string;
    severity: AlertProps['severity'];
};

export const simpleAlertAtom = atom<SimpleAlert>({
    show: false,
    title: '',
    severity: 'success',
});
